import React from "react";
import { Minus, Plus } from "lucide-react";

// Número com botões − e + (sem digitar).
export default function Contador({ valor, min, max, onMudar, rotulo, e2e }) {
  const n = Number(valor) || min;
  const botao = "w-9 h-9 rounded-lg border flex items-center justify-center hover:bg-muted disabled:opacity-40 disabled:hover:bg-transparent";
  return (
    <div className="inline-flex items-center gap-2" data-e2e={e2e}>
      <button type="button" className={botao} disabled={n <= min} onClick={() => onMudar(Math.max(min, n - 1))} aria-label={`Diminuir ${rotulo}`}>
        <Minus className="w-4 h-4" />
      </button>
      <span className="w-10 text-center text-xl font-bold tabular-nums" aria-live="polite">{n}</span>
      <button type="button" className={botao} disabled={n >= max} onClick={() => onMudar(Math.min(max, n + 1))} aria-label={`Aumentar ${rotulo}`}>
        <Plus className="w-4 h-4" />
      </button>
    </div>
  );
}
